import ReactOnRails from 'react-on-rails';

import Briefing from '@components/pages/Briefing';

ReactOnRails.register({
  Briefing,
});
